<template>
  <grid
    grid-id="details-cases-grid"
    :no-records="'No associated cases found'"
    :fields="fields"
    :items="details.cases"
    :get-items-function="getCasesDetailsData"
    :total-rows="details.casesPaging.totalItems"
    :current-page="details.casesPaging.pageNumber"
    :per-page="details.casesPaging.pageSize"
    :sort-by="details.casesPaging.sortBy"
    :sort-order="details.casesPaging.sortOrder"
  />
</template>

<script>
import gridFields from '../../../../../fields';

import Grid from '@/shared/components/Grid';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
export default {
  components: {
    Grid
  },
  props: ['companyId'],
  data() {
    return {
      fields: [
        // { key: 'commands', label: '', tdClass: 'grid-commands-width-1' },
        { key: 'caseId', label: 'Case Id' },
        { key: 'caseNumber', label: 'Case Number' },
        { key: 'channel', label: 'Channel' },
        { key: 'caseName', label: 'Client' },
        { key: 'caseStatus', label: 'Status' },
        { key: 'startDate', label: 'Start Date' },
        { key: 'nextRenewalDate', label: 'Next Renewal' },
        { key: 'enrollDate', label: 'EnrollDate' },
        { key: 'eligibles', label: '#Eligibles' },
        { key: 'target', label: '#Targets' },
        { key: 'enrolled', label: '#Enrolled' },
        { key: 'mum', label: '#MUM' },
        {
          key: 'currentMonthlyRevenue',
          label: 'Monthly Revenue'
        },
        { key: 'revenueToDate', label: 'Total Revenue' }
      ]
    };
  },
  computed: {
    ...mapState('companies', ['details'])
  },
  methods: {
    ...mapActions('companies', ['getCasesDetails']),
    async getCasesDetailsData(pagingData) {
      await this.getCasesDetails({ companyId: this.companyId, ...pagingData });
    }
  }
};
</script>